import Vue from 'vue';
import Vuex from 'vuex';

import axios from 'axios';
import _ from 'lodash';
import api from '@/configs/api';
import helpers from '@/common/helpers';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        categories: {
            all: [],
            id: 0
        },

        messages: {
            list: [],
            id: 0,
            done: false
        }
    },

    getters: {
        getCategory: state => {
            return _.find(state.categories.all, { id: state.categories.id }) || {};
        },

        getMessage: state => {
            return _.find(state.messages.list, { id: state.messages.id }) || {};
        },

        isStepsNew: state => {
            return state.messages.list.filter(item => { return item.state !== 'new' }).length === 0;
        },

        isStepsDone: state => {
            let isDoneAllMessages = state.messages.list.filter(item => { return ~['new', 'progress'].indexOf(item.state) }).length === 0;
            return isDoneAllMessages || state.messages.done;
        },

        getMessagesByState: state => messageState => {
            return state.messages.list.filter(item => { return item.state === messageState });
        }
    },

    mutations: {
        SET_CATEGORIES (state, categories) {
            state.categories.all = categories;
        },

        SET_CATEGORY_ID (state, categoryId) {
            state.categories.id = categoryId;
        },

        SET_MESSAGES (state, messages) {
            state.messages.list = messages;
        },

        SET_MESSAGE_ID (state, messageId) {
            state.messages.id = messageId;
        },

        SET_MESSAGE_STATE (state, messageState) {
            _.find(state.messages.list, { id: state.messages.id }).state = messageState;
        },

        SET_MESSAGES_DONE (state, done) {
            state.messages.done = done;
        }
    },

    actions: {
        getCategories (context) {
            return new Promise((resolve, reject) => {
                if (context.state.categories.all.length) {
                    resolve(context.state.categories.all);
                } else {
                    axios
                        .get(api.categories)
                        .then(response => {
                            context.commit('SET_CATEGORIES', response.data)
                            resolve(response.data);
                        });
                }
            });
        },

        setCategoryId (context, categoryId) {
            context.commit('SET_CATEGORY_ID', categoryId);
        },

        getMessagesByCategoryId (context, categoryId) {
            const url = api.messages.byCategory.replace('{id}', categoryId);

            return new Promise((resolve, reject) => {
                axios.get(url).then(response => {
                    let messages = helpers.messages.parse(response.data);
                    context.commit('SET_MESSAGES', messages);
                    context.commit('SET_MESSAGES_DONE', false);
                    resolve(messages);
                });
            });
        },

        nextMessage (context) {
            let newMessages = context.state.messages.list.filter(item => { return item.state === 'new' });
            let nextId = newMessages[Math.floor(Math.random() * (newMessages.length))].id;

            context.commit('SET_MESSAGE_ID', nextId);
            context.commit('SET_MESSAGE_STATE', 'progress');
        },

        setMessageState (context, messageState) {
            context.commit('SET_MESSAGE_STATE', messageState);
        },

        setMessagesDone (context, done) {
            context.commit('SET_MESSAGES_DONE', done);
        }
    }
});
